export const CtxWorkflowApps = {
  DEAL_MANAGER: {
      name: 'DM',
      entities: 'Deals',
  },
  KARGO_MARKETPLACE: {
      name: 'KM',
      entities: 'Line Items',
  },
};
